import type { PlacemarkI } from '@components/MapRender';

const SHOP_ICON = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M20.9836 8.06709L19.9655 3.87595C19.8406 3.36103 19.3906 3 18.8742 3H5.12786C4.61149 3 4.16149 3.36103 4.03549 3.87595L3.01736 8.06709C3.00611 8.11222 3.00049 8.15966 3.00049 8.2071C3.00049 9.80163 4.19861 11.0999 5.67236 11.0999C6.52849 11.0999 7.29236 10.6614 7.78174 9.98099C8.27111 10.6614 9.03499 11.0999 9.89111 11.0999C10.7472 11.0999 11.5111 10.6614 12.0005 9.98099C12.4899 10.6614 13.2526 11.0999 14.1099 11.0999C14.9671 11.0999 15.7299 10.6614 16.2192 9.98099C16.7086 10.6614 17.4714 11.0999 18.3286 11.0999C19.8024 11.0999 21.0005 9.80163 21.0005 8.2071C21.0005 8.15966 20.9949 8.11222 20.9836 8.06709Z"
        fill="white"/>
  <path d="M18.3286 12.3304C17.5625 12.3304 16.8346 12.0643 16.2192 11.5781C14.9885 12.5517 13.2312 12.5517 12.0005 11.5781C10.7697 12.5517 9.01249 12.5517 7.78174 11.5781C7.16636 12.0643 6.43849 12.3304 5.67236 12.3304C5.11999 12.3304 4.59911 12.1832 4.12549 11.9325V19.7216C4.12549 20.4277 4.62949 21.0009 5.25049 21.0009H9.75049V14.889H14.2505V21.0009H18.7505C19.3715 21.0009 19.8755 20.4277 19.8755 19.7216V11.9325C19.4019 12.1832 18.881 12.3304 18.3286 12.3304Z"
        fill="white"/>
</svg>`;

const CAFE_ICON = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12.0002 14.6673C15.6821 14.6673 18.6668 12.2795 18.6668 9.33398H5.3335C5.3335 12.2795 8.31826 14.6673 12.0002 14.6673Z"
        fill="white"/>
  <path d="M8.00016 21.3327H12.0002M16.0002 21.3327H12.0002M12.0002 14.8711V21.3327M12.0002 14.8711C6.66683 14.8711 5.3335 11.0421 5.3335 9.12755M12.0002 14.8711C17.3335 14.8711 18.6668 11.0421 18.6668 9.12755M5.3335 9.12755L6.50218 3.46392C6.59805 2.99932 7.00716 2.66602 7.48155 2.66602H16.5188C16.9932 2.66602 17.4023 2.99932 17.4981 3.46392L18.6668 9.12755M5.3335 9.12755H18.6668"
        stroke="white" stroke-width="2.5" stroke-linecap="round"/>
</svg>`;

interface PlacemarkStore {
  type?: string | null;
}

export const createPlacemarkWithQuantityOptions = (
  item: PlacemarkStore,
  isActive = false,
  availableQuantity = 0
): PlacemarkI['options'] => {
  const icon =
    item.type === 'cafe' || item.type === 'oyster_bar' ? CAFE_ICON : SHOP_ICON;

  const size = [60, 70];
  const offset = [-30, -70];

  const blockStyles = isActive
    ? { background: '#B32442', textColor: 'white' }
    : { background: 'white', textColor: '#363636' };

  const svgContent = `
    <svg width="${size[0]}" height="${
    size[1]
  }" xmlns="http://www.w3.org/2000/svg"
         style="image-rendering: auto; -webkit-transform: translateZ(0); transform: translateZ(0);">
      <defs>
        <filter id="drop-shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="2" stdDeviation="4" flood-color="rgba(0,0,0,0.3)"/>
        </filter>
        <style>
          .quantity-block {
            fill: ${blockStyles.background};
            transition: fill 0.2s ease;
          }
          .placemark-group:hover .quantity-block {
            fill: #B32442;
          }
        </style>
      </defs>

      <g class="placemark-group" filter="url(#drop-shadow)">
        <circle cx="30" cy="20" r="20"
                fill="#B32442"
                stroke="white"
                stroke-width="2"/>

        <g transform="translate(18, 8)">
          ${icon}
        </g>

        <rect x="6" y="44" width="48" height="20"
              class="quantity-block"
              stroke="none"
              rx="10"/>

        <foreignObject x="6" y="44" width="48" height="20">
          <div xmlns="http://www.w3.org/1999/xhtml" style="
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
            font-size: 12px;
            font-weight: 600;
            color: ${blockStyles.textColor};
            text-rendering: optimizeSpeed;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-align: center;
            line-height: 1;
          ">${availableQuantity > 0 ? `${availableQuantity} шт` : 'Нет'}</div>
        </foreignObject>
      </g>
    </svg>
  `;

  return {
    iconLayout: 'default#image',
    iconImageHref:
      'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent),
    iconImageSize: size,
    iconImageOffset: offset
  };
};
